export default __webpack_public_path__ + "static/media/sandoog-logo.e8abfe97.png";